<template>
    <div>
        <template v-if="pageVue.headerBanner">
            <showcase-header-banner
                :background-color="pageVue.headerBanner.backgroundColor"
                :icon="pageVue.headerBanner.icon"
                :label="pageVue.headerBanner.label"
            />
        </template>

        <section id="page-header">
            <div class="container-fluid my-2 my-md-3">
                <div class="row">
                    <div class="col-12">
                        <!-- Pack Mobile + Internet -->
                        <h1 v-html="pageVue.pageTitle" />
                    </div>
                </div>
                <!--/* LIEN Remise */-->
                <div class="row mb-md-2 mb-1">
                    <div class="col-12">
                        <p class="lead mb-1 p-0">
                            <!-- Prix du pack avec -->
                            <span v-html="pageVue.priceValidityLabel0" />
                            <span>
                                <!-- remises incluses -->
                                <a href="#mentions" v-html="pageVue.priceValidityLink" />
                            </span>
                            <!-- valables jusqu'au 03/02/2021 -->
                            <span v-html="pageVue.priceValidityLabel1" />
                        </p>
                    </div>
                </div>
            </div>
        </section>


        <internet-and-mobile-on-boarding
            v-if="pageVue.onBoardingComponent"
            :on-boarding-offer-description-text="pageVue.onBoardingComponent.offerDescriptionText"
            :on-boarding-yearly-discounts-info-text="pageVue.onBoardingComponent.yearlyDiscountsInfoText"
            :button-label="pageVue.onBoardingComponent.buttonLabel"
            :discount-advantages-popin="pageVue.onBoardingComponent.discountAdvantagesPopin"
        />

        <section id="internet-and-mobile-offers">
            <eligibility-form
                :token="token"
                :init-eligibility-url="pageVue.initEligibilityUrl"
                :mobile-offers-model="pageVue.mobileOffersModel"
                :internet-offers-model="pageVue.internetOffersModel"
            />

            <EligibilityResult
                v-if="pageVue.topEligibilityResult"
                :eligibility-result="pageVue.topEligibilityResult"
            />

            <!--/* NAV LINK: "Packs du moment" VS "Composer un pack" */-->
            <div id="recommend-or-compose-pack-navigation" class="container-fluid mb-3">
                <nav class="ob1-menu-page ob1-menu-page-fullscreen" style="height: auto !important;">
                    <ul class="nav ob1-nav-light">
                        <li class="nav-item" :class="{'active': showOnlyRecommendedOffers}">
                            <!-- Packs du moment -->
                            <button
                                class="nav-link px-0"
                                :data-oevent-category="pageVue.tmsButtonPackMoment.category"
                                :data-oevent-action="pageVue.tmsButtonPackMoment.action"
                                :data-oevent-label="pageVue.tmsButtonPackMoment.label"
                                @click="changeSelectedTab(hashTagPackDuMoment)"
                                v-text="pageVue.recommendedPackTabLabel"
                            />
                        </li>
                        <li class="nav-item" :class="{'active': !showOnlyRecommendedOffers}">
                            <!-- Composer un pack -->
                            <button
                                class="nav-link px-0"
                                :data-oevent-category="pageVue.tmsButtonComposerPack.category"
                                :data-oevent-action="pageVue.tmsButtonComposerPack.action"
                                :data-oevent-label="pageVue.tmsButtonComposerPack.label"
                                @click="changeSelectedTab(hashTagComposerUnPack)"
                                v-text="pageVue.composePackTabLabel"
                            />
                        </li>
                    </ul>
                </nav>
            </div>

            <!--/* NAV LINK "Packs du moment" content */-->
            <div v-if="showOnlyRecommendedOffers">
                <!--/* VUE JS OFFRES - recommandées */-->
                <recommended-offers
                    :internet-offers-model="pageVue.internetOffersModel"
                    :mobile-offers-model="pageVue.mobileOffersModel"
                    :mobile-offers-tiles="pageVue.mobileOffersComponent.mobileOffersTiles"
                    :internet-offers-tiles="pageVue.internetOffersComponent.internetOffersTiles"
                    :recommended-offers-data="pageVue.recommendedOffersComponent"
                    :show-eligibility-result="false"
                    :fo-link-query-params="foLinkQueryParams"
                />
                <!--/* PUSH ANIMATION */-->
                <div v-if="pageVue.recommendedAnimationPush">
                    <div class="container-fluid px-2 px-lg-1 pb-2 mb-2">
                        <div class="row py-1">
                            <div class="col-12 pb-1">
                                <push-animation :push-animation="pageVue.recommendedAnimationPush" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--/* NAV LINK "Composer un pack" content */-->
            <div v-if="!showOnlyRecommendedOffers">
                <!--/* VUE JS OFFRES - mobile */-->
                <mobile-offers
                    :mobile-offers-data="pageVue.mobileOffersComponent"
                    :mobile-offers-model="pageVue.mobileOffersModel"
                    :selected-mobile-offer-seo-id="selectedMobileOfferSeoId"
                    :fo-link-query-params="foLinkQueryParams"
                    @select-mobile-offer-seo-id="selectMobileOffer($event)"
                />

                <!--/* VUE JS OFFRES - internet */-->
                <internet-offers
                    :internet-offers-data="pageVue.internetOffersComponent"
                    :selected-internet-offer-seo-id="selectedInternetOfferSeoId"
                    :internet-offers-filter="internetOffersFilter"
                    :detail-page-query-params="detailPageQueryParams"
                    @select-internet-offer-seo-id="selectInternetOffer($event)"
                    @after-swiper-update="afterSwiperUpdate"
                    @update-filter-equipment="updateFilterEquipment($event)"
                />

                <!--/* VUE JS RECAP - panier */-->
                <cart-recap
                    :cart-recap-data="pageVue.cartRecapComponent"
                    :mobile-offers-model="pageVue.mobileOffersModel"
                    :selected-internet-offer-seo-id="selectedInternetOfferSeoId"
                    :selected-mobile-offer-seo-id="selectedMobileOfferSeoId"
                    :internet-offers-tiles="pageVue.internetOffersComponent.internetOffersTiles"
                    :mobile-offers-tiles="pageVue.mobileOffersComponent.mobileOffersTiles"
                    :new-pack-summaries-by-seo-ids="pageVue.newPackSummariesBySeoIds"
                    :blocked-mobile-offer-title="pageVue.cartRecapComponent.blockedMobileOfferTitle"
                    :blocked-mobile-offer-toggle-tms="pageVue.cartRecapComponent.blockedMobileOfferToggleTms"
                    :blocked-mobile-offer-popin-tms="pageVue.cartRecapComponent.blockedMobileOfferPopinTms"
                    :about-blocked-mobile-offer-popin="pageVue.cartRecapComponent.aboutBlockedMobileOfferPopin"
                    :show-eligibility-result="false"
                    :position="hashTag"
                    @select-mobile-offer-seo-id="selectVariationMobileOffer($event)"
                />
            </div>

            <!--/* AVANTAGES */-->
            <internet-and-mobile-advantages
                :advantages-title="pageVue.advantagesTitle"
                :advantages-list="pageVue.advantagesListOfAttributes"
            />

            <div v-if="pageVue.faq" class="container-fluid">
                <showcase-faq
                    :faq-title="pageVue.faq.faqTitle"
                    :faq-list-of-attributes="pageVue.faq.faqListOfAttributes"
                />
            </div>

            <internet-and-mobile-legal-mentions
                :legal-mentions-title="pageVue.legalMentionsTitle"
                :legal-mentions-text="pageVue.legalMentionsText"
                :hands-free-text="pageVue.handsFree"
            />

            <ob1-snack-bar
                v-if="pageVue.showSnackbar"
                id="techno-snackbar"
                ref="technoSnackbar"
                :icon="pageVue.snackbarComponent.snackbarIcon"
                :label="pageVue.snackbarComponent.snackbarLabel"
            />

            <!--/* POPIN FOR RECOMMENDED OFFER */-->
            <xdsl-line-intention-popin
                v-if="pageVue.xdslLineIntentionPopinRecommended && recommendedXdslLineIntentions"
                :dto-from-object="pageVue.xdslLineIntentionPopinRecommended"
                :xdsl-line-intentions="recommendedXdslLineIntentions"
            />

            <template v-if="pageVue.deviceIntentionPopinRecommended && recommendedDeviceIntentions">
                <device-intention-popin
                    v-for="deviceIntention in recommendedDeviceIntentions"
                    :key="deviceIntention.popinModal ? deviceIntention.popinModal.id : pageVue.deviceIntentionPopinRecommended.popinModal.id"
                    :title="pageVue.deviceIntentionPopinRecommended.title"
                    :visual="pageVue.deviceIntentionPopinRecommended.visual"
                    :text-sub="pageVue.deviceIntentionPopinRecommended.textSub"
                    :subsidized="recommendedMobileOffer ? recommendedMobileOffer.subsidized : false"
                    :text4x-cb="pageVue.deviceIntentionPopinRecommended.text4xCb"
                    :enable4x-cb="pageVue.deviceIntentionPopinRecommended.enable4xCb"
                    :page-title="pageVue.deviceIntentionPopinRecommended.pageTitle"
                    :page-type="pageVue.deviceIntentionPopinRecommended.pageType"
                    :popin-modal="deviceIntention.popinModal ? deviceIntention.popinModal : pageVue.deviceIntentionPopinRecommended.popinModal"
                    :with-device-button-cta="deviceIntention.withDeviceButtonCta"
                    :without-device-button-cta="deviceIntention.withoutDeviceButtonCta"
                />
            </template>

            <device-intention-popin
                v-if="pageVue.deviceIntentionPopinRecommended && pageVue.recommendedOffersComponent.packSummary.deviceIntention"
                :title="pageVue.deviceIntentionPopinRecommended.title"
                :visual="pageVue.deviceIntentionPopinRecommended.visual"
                :text-sub="pageVue.deviceIntentionPopinRecommended.textSub"
                :subsidized="recommendedMobileOffer ? recommendedMobileOffer.subsidized : false"
                :text4x-cb="pageVue.deviceIntentionPopinRecommended.text4xCb"
                :enable4x-cb="pageVue.deviceIntentionPopinRecommended.enable4xCb"
                :page-title="pageVue.deviceIntentionPopinRecommended.pageTitle"
                :page-type="pageVue.deviceIntentionPopinRecommended.pageType"
                :popin-modal="pageVue.deviceIntentionPopinRecommended.popinModal"
                :with-device-button-cta="pageVue.recommendedOffersComponent.packSummary.deviceIntention.withDeviceButtonCta"
                :without-device-button-cta="pageVue.recommendedOffersComponent.packSummary.deviceIntention.withoutDeviceButtonCta"
            />

            <!--/* POPIN FOR CART RECAP */-->
            <xdsl-line-intention-popin
                v-if="pageVue.xdslLineIntentionPopin && selectedXdslLineIntentions"
                :dto-from-object="pageVue.xdslLineIntentionPopin"
                :xdsl-line-intentions="selectedXdslLineIntentions"
            />

            <template v-if="pageVue.deviceIntentionPopin">
                <device-intention-popin
                    v-for="deviceIntention in selectedDeviceIntentionList"
                    :key="deviceIntention.popinModal ? deviceIntention.popinModal.id : pageVue.deviceIntentionPopin.popinModal.id"
                    :title="pageVue.deviceIntentionPopin.title"
                    :visual="pageVue.deviceIntentionPopin.visual"
                    :text-sub="pageVue.deviceIntentionPopin.textSub"
                    :subsidized="mobileOffer ? mobileOffer.subsidized : false"
                    :text4x-cb="pageVue.deviceIntentionPopin.text4xCb"
                    :enable4x-cb="pageVue.deviceIntentionPopin.enable4xCb"
                    :page-title="pageVue.deviceIntentionPopin.pageTitle"
                    :page-type="pageVue.deviceIntentionPopin.pageType"
                    :popin-modal="deviceIntention.popinModal ? deviceIntention.popinModal : pageVue.deviceIntentionPopin.popinModal"
                    :with-device-button-cta="deviceIntention.withDeviceButtonCta"
                    :without-device-button-cta="deviceIntention.withoutDeviceButtonCta"
                />
            </template>

            <device-intention-popin
                v-if="pageVue.deviceIntentionPopin && selectedDeviceIntention"
                :title="pageVue.deviceIntentionPopin.title"
                :visual="pageVue.deviceIntentionPopin.visual"
                :text-sub="pageVue.deviceIntentionPopin.textSub"
                :subsidized="mobileOffer ? mobileOffer.subsidized : false"
                :text4x-cb="pageVue.deviceIntentionPopin.text4xCb"
                :enable4x-cb="pageVue.deviceIntentionPopin.enable4xCb"
                :page-title="pageVue.deviceIntentionPopin.pageTitle"
                :page-type="pageVue.deviceIntentionPopin.pageType"
                :popin-modal="pageVue.deviceIntentionPopin.popinModal"
                :with-device-button-cta="selectedDeviceIntention.withDeviceButtonCta"
                :without-device-button-cta="selectedDeviceIntention.withoutDeviceButtonCta"
            />
        </section>
    </div>
</template>

<script>
import InternetAndMobileOnBoarding from "./InternetAndMobileOnBoarding.vue";
import InternetAndMobileAdvantages from "./InternetAndMobileAdvantages.vue";
import InternetAndMobileLegalMentions from "./InternetAndMobileLegalMentions.vue";
import EligibilityForm from "./EligibilityForm.vue";
import RecommendedOffers from "./RecommendedOffers.vue";
import MobileOffers from "./MobileOffers.vue";
import XdslLineIntentionPopin from "../../../../../../common/broadband/components/XdslLineIntentionPopin.vue";
import DeviceIntentionPopin from "../../../../../../common/broadband/components/DeviceIntentionPopin.vue";
import ShowcaseHeaderBanner from "./ShowcaseHeaderBanner.vue";
import ShowcaseFaq from "./ShowcaseFaq.vue";
import EligibilityResult from "./eligibility/EligibilityResult.vue";
import InternetOffers from "./InternetOffers.vue";
import CartRecap from "./CartRecap.vue";
import {alignDivHeights} from "../../../../utils/AlignDivHeightsUtil";
import PushAnimation from "../../../../../broadband/components/PushAnimation.vue";

export default {
    name: "InternetAndMobileShowcase",
    components: {
        EligibilityResult,
        ShowcaseFaq,
        ShowcaseHeaderBanner,
        DeviceIntentionPopin,
        XdslLineIntentionPopin,
        CartRecap,
        InternetOffers,
        MobileOffers,
        RecommendedOffers,
        EligibilityForm,
        InternetAndMobileLegalMentions,
        InternetAndMobileAdvantages,
        InternetAndMobileOnBoarding,
        PushAnimation
    },
    props: {
        token: {type: String, required: true},
        pageVue: {type: Object, required: true},
    },
    data() {
        return {
            hashTagPackDuMoment: "pack_du_moment",
            hashTagComposerUnPack: "composer_un_pack",
            hashTagComposerUnPackAvecTv: "composer_un_pack_avec_tv",
            hashTagComposerUnPackSansTv: "composer_un_pack_sans_tv",
            hashTag: undefined,
            updateOfSelectedInternetOfferSeoId: undefined,
            updateOfSelectedMobileOfferSeoId: undefined,
            updateOfTerminalSelectionScrollDone: undefined,
            swiperSlidesPerView: 1.2,
            swiperPagination: false,
            swiperPaddingBottomInPx: 0,
            swiperSpaceBetween: 30,
            swiperNavigation: false,
            swiperBreakpoints: {
                // when window width is <= 560px
                560: {
                    slidesPerView: 1.4
                },
                // when window width is <= 662px
                662: {
                    slidesPerView: 1.8
                },
                // when window width is <= 736px
                736: {
                    slidesPerView: 2
                }
            },
            listOfDivToAlign: [
                "mobile-banner", "mobile-title", "mobile-attributes", "mobile-short-description", "mobile-promo", "mobile-ob1-price",
                "mobile-open-discount", "mobile-selection", "mobile-claim-content", "mobile-claim",
                "internet-banner", "internet-title", "internet-debit", "internet-claim-content", "internet-claim",
                "internet-ob1-price", "internet-selection",
                "recap-claim", "recap-ob1-price",
                "reco-banner", "reco-title", "reco-ob1-price", "reco-claim", "info-container",
                "tag-timer", "title-align", "debit",
                "claim-0", "claim-1", "claim-2", "claim-3",
                "claim-content-0", "claim-content-1", "claim-content-2", "claim-content-3",
                "claims-container",
                "internet-secondary", "cross-discount-banner",
                "price-align", "mobileprice-align", "offer-edito-content", "detail-link-align"
            ]
        }
    },
    computed: {
        detailPageQueryParams() {
            return {
                offreInternet: this.selectedInternetOfferSeoId,
                offreMobile: this.selectedMobileOfferSeoId,
                vitrineHashTag: this.hashTag
            }
        },
        foLinkQueryParams() {
            return this.detailPageQueryParams;
        },
        showOnlyRecommendedOffers() {
            if ((this.hashTag) && (this.hashTag !== "")) {
                // Si un hashTag existe, définir showOnlyRecommendedOffers à partir du hashTag
                return (this.hashTag !== this.hashTagComposerUnPack
                    && this.hashTag !== this.hashTagComposerUnPackSansTv
                && this.hashTag !== this.hashTagComposerUnPackAvecTv);
            }
            return true;
        },
        selectedInternetOfferSeoId() {
            if (this.updateOfSelectedInternetOfferSeoId !== undefined) {
                return this.updateOfSelectedInternetOfferSeoId
            }
            return this.pageVue.selectedInternetOfferSeoId
        },
        selectedMobileOfferSeoId() {
            if (this.updateOfSelectedMobileOfferSeoId !== undefined) {
                return this.updateOfSelectedMobileOfferSeoId
            }
            return this.pageVue.selectedMobileOfferSeoId
        },
        terminalSelectionScrollDone() {
            if (this.updateOfTerminalSelectionScrollDone !== undefined) {
                return this.updateOfTerminalSelectionScrollDone
            }
            return this.pageVue.terminalSelectionScrollDone
        },
        selectedOffer() {
            return this.pageVue.newPackSummariesBySeoIds[this.selectedInternetOfferSeoId][this.selectedMobileOfferSeoId]
        },
        selectedDeviceIntention() {
            return this.selectedOffer.deviceIntention
        },
        mobileOffer() {
            return this.pageVue.mobileOffersModel && this.pageVue.mobileOffersModel.find(offer => offer.seoId === this.selectedMobileOfferSeoId)
        },
        selectedXdslLineIntentionPopin() {
            return this.pageVue.deviceIntentionPopin
        },
        selectedXdslLineIntentions() {
            return this.selectedOffer.xdslLineIntentions ? this.selectedOffer.xdslLineIntentions.map(i => i.first) : null
        },
        selectedDeviceIntentionList() {
            return this.selectedOffer.xdslLineIntentions ? this.selectedOffer.xdslLineIntentions.map(i => i.second).filter(i => i !== undefined) : null
        },
        recommendedMobileOffer() {
            return this.pageVue.mobileOffersComponent.mobileOffersTiles.find(
                tile => tile.seoId === this.pageVue.mobileOffersModel.find(model => model.highlighted === true).seoId
            )
        },
        recommendedXdslLineIntentions() {
            return this.pageVue.recommendedOffersComponent.packSummary.xdslLineIntentions
                ? this.pageVue.recommendedOffersComponent.packSummary.xdslLineIntentions.map(i => i.first) : null
        },
        recommendedDeviceIntentions() {
            return this.pageVue.recommendedOffersComponent.packSummary.xdslLineIntentions
                ? this.pageVue.recommendedOffersComponent.packSummary.xdslLineIntentions
                    .map(i => i.second)
                    .filter(i => i !== undefined) : null
        },
        internetOffersFilter() {
            if (this.hashTag === this.hashTagComposerUnPack) {
                return null
            } else if (this.hashTag === this.hashTagComposerUnPackSansTv) {
                return false
            } else if (this.hashTag === this.hashTagComposerUnPackAvecTv) {
                return true
            } else {
                return null
            }
        },
        hashTags() {
            return [this.hashTagPackDuMoment, this.hashTagComposerUnPack, this.hashTagComposerUnPackAvecTv, this.hashTagComposerUnPackSansTv]
        }
    },
    watch: {
        showOnlyRecommendedOffers(_newVal, _oldVal) {
            this.alignDisplayedDivs()
        }
    },
    mounted() {
        this.alignDisplayedDivs();
        window.addEventListener("resize", () => {
            this.alignDisplayedDivs()
        });
        this.showSnackbar();
        window.addEventListener("hashchange", this.updateSelectedTabFromHash);
        this.updateSelectedTabFromHash();
        if (this.hashTag === this.hashTagComposerUnPack) {
            this.updateFilterEquipment(this.pageVue.internetOffersComponent.defaultFilterForEquipment)
        }
    },
    beforeDestroy: function () {
        window.removeEventListener("hashchange", this.updateSelectedTabFromHash);
    },
    methods: {
        afterSwiperUpdate() {
            this.alignDisplayedDivs()
        },
        alignDisplayedDivs() {
            alignDivHeights(this.listOfDivToAlign);
        },
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash
        },
        updateSelectedTabFromHash() {
            const hash = this.readHash();
            if (hash !== this.hashTag) {
                if (hash === "") {
                    this.hashTag = "";
                } else if (this.hashTags.includes(hash)) {
                    this.hashTag = hash;
                }
            }
        },
        changeSelectedTab(e) {
            if ((e !== "") && (this.hashTags.includes(e))) {
                if (e === this.hashTagComposerUnPack) {
                    this.updateFilterEquipment(this.pageVue.internetOffersComponent.defaultFilterForEquipment)
                } else {
                    window.location.href = "#" + e;
                }
            }
        },
        displayOnlyRecommendedOffers(newValue) {
            if (this.showOnlyRecommendedOffers !== newValue) {
                this.showOnlyRecommendedOffers = newValue
            }
        },
        selectMobileOffer(offerSeoId) {
            this.updateOfSelectedMobileOfferSeoId = offerSeoId
            if (!this.terminalSelectionScrollDone) {
                let nextElement = document.getElementById('internet-offers')
                if (nextElement != null) {
                    nextElement.scrollIntoView({behavior: "smooth"})
                }
                this.updateOfTerminalSelectionScrollDone = true;
            }
            this.postSelection();
        },
        selectVariationMobileOffer(offerSeoId) {
            this.updateOfSelectedMobileOfferSeoId = offerSeoId
            this.updateDisplayTile(offerSeoId)
            this.postSelection();
        },
        selectInternetOffer(offerSeoId) {
            this.updateOfSelectedInternetOfferSeoId = offerSeoId
            this.postSelection();
        },
        updateFilterEquipment(equipmentFilterState) {
            if (equipmentFilterState == null) {
                window.location.href = "#" + this.hashTagComposerUnPack;
            } else if (equipmentFilterState === true) {
                window.location.href = "#" + this.hashTagComposerUnPackAvecTv;
            } else if (equipmentFilterState === false) {
                window.location.href = "#" + this.hashTagComposerUnPackSansTv;
            }
        },
        // fonction pour changer la valeur de "displayTile" pour l'offre correspondant au "seoId" spécifié
        updateDisplayTile(seoId) {
            const object = this.pageVue.mobileOffersModel.find(o => o.seoId === seoId);
            object.displayTile = !object.displayTile;

            const variationObject = this.pageVue.mobileOffersModel.find(o => o.seoId === object.variationOfferSeoId);
            if (variationObject) {
                variationObject.displayTile = !variationObject.displayTile;
            }
        },
        postSelection() {
            const params = {
                internetOfferParam: this.selectedInternetOfferSeoId,
                mobileOfferParam: this.selectedMobileOfferSeoId,
                terminalSelectionScrollDone: this.terminalSelectionScrollDone,
                mobileOffersModel: this.pageVue.mobileOffersModel,
                token: this.token
            };
            new MshRequest().postJson(this.pageVue.postSelectionUrl, params).then(returnAjax => {
                if (returnAjax.success !== true) {
                    document.location.reload();
                }
                const url = new URL(window.location.href);
                url.searchParams.set('offreInternet', this.selectedInternetOfferSeoId);
                url.searchParams.set('offreMobile', this.selectedMobileOfferSeoId);
                window.history.pushState({}, '', url);
            });
        },
        showSnackbar() {
            // initialisation de tous les composants de la page
            // qui n'ont pas encore été initialisés (à cause du chargement de contenu à afficher par requête AJAX)
            ob1.Ob1Component.load(document.body);
            const snackbar = this.$refs.technoSnackbar;
            if (snackbar) {
                snackbar.show();
            }
        }
    }
}
</script>

<style scoped lang="scss">

// hack hauteur tuiles noires EDITO
.swiper-slide-height {
    height: auto !important;
}

</style>
